import React from 'react'

import { Navbar } from '../components/Navbar';
import { Header } from '../components/Header';
import SkillsCloud from '../components/SkillsCloud';
import { Projects } from '../components/Projects';
import { Footer } from '../components/Footer';
import { Skills } from '../components/Skills';

export function Home() {
    return (
        <div>
            <Navbar />
            <Header />
            <SkillsCloud />
            <Skills />
            <Projects />
            <Footer />
        </div>
    )
}
